module.exports = __webpack_public_path__ + "images/4-en.c043d26ae96bfae47b9807a4b6b278ce.jpg";